import React, { Component } from 'react';
import "./home.css";
import myFace from './myFace.png';

export default class Home extends Component {
    render() {
      return (
          <div id="content">
              <img class="picOfMyFace" src={myFace} alt="My face" width="369" height="430"/>
              <div id="name-and-jobtitle">
                  <h1>Marcus Thorn Mathiesen</h1>
                  <p>Software developer</p>
              </div>
              <div id="about-me">
                  <h1>About me</h1>
                  <p>I am an energetic person that loves to solve problems and learn.</p>
                  <p> I currently work part-time as a Software Engineer at Danske Bank and studies Computer Science at the University of Copenhagen.</p>
                  <p> I love to learn and in my sparetime I like to read quite a lot within different topics including phyilosophy, psychology, economics, mathematics, and of course computer science.</p>
              </div>  
              <div id="details">
                  <h1>Details</h1>
                  <ul>
                    <li><strong>Name:</strong> Marcus Thorn Mathiesen</li>
                    <li><strong>Age:</strong> 21</li>
                    <li><strong>Residence:</strong> 2200 Copenhagen, Denmark</li>
                  </ul> 
              </div>     
          </div>
      );
    }
}